// Only themes are allowed to import scss files.
// eslint-disable-next-line import/no-unassigned-import
import '../../../../scss/themes/default/default.scss';

function AutoschmittTheme() {
    return null;
}

export default AutoschmittTheme;
